import { render, staticRenderFns } from "./WarehouseTransferModal.vue?vue&type=template&id=24555cf4&"
import script from "./WarehouseTransferModal.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports